import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-content">
          <div className="hero-image-container">
            <img
              src="/img/dilverbloom-products/product-23.jpg"
              alt="Dilverbloom Italian espresso gift set"
              className="hero-image"
            />
          </div>
          <div className="hero-text">
            <h1>For the love of Italy</h1>
            <p className="subtitle">Dilverbloom's Story</p>
          </div>
        </div>
        <div className="decorative-divider"></div>
      </section>

      {/* Intro Section */}
      <section className="intro-section">
        <div className="intro-header">
          <h3 className="section-label">GET TO KNOW US</h3>
          <div className="decorative-squiggle">
            <img alt="" src="/head/curb.svg" />
          </div>
        </div>
        <div className="intro-content">
          <div className="intro-text">
            <p>
              Dilverbloom began with a simple purpose: make thoughtfully chosen
              Italian pantry staples easier to discover and enjoy at home. We
              work with specialty-food partners, learn the traditions behind
              each recipe, and bring together versatile ingredients, snacks,
              sweets, coffee, and gifts for food lovers across America.
            </p>
          </div>
          <div className="quote-section">
            <p className="quote-text">
              Tradition and passion are at the heart of our family. Having our
              products showcased by Dilverbloom, which shares these values, is
              priceless.
            </p>
            <div className="quote-author">
              <div className="author-line"></div>
              <span className="quote-mark">”</span>
              <span className="author-name">THE DILVERBLOOM TEAM</span>
            </div>
            <div className="food-illustrations">
              <img
                src="/main/a2-1.svg"
                alt="Pasta illustration"
                className="illustration-1"
              />
              <img
                src="/main/a2-2.svg"
                alt="Tomato illustration"
                className="illustration-2"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Sourcing Section */}
      <section className="sourcing-section">
        <div className="sourcing-content">
          <div className="sourcing-image-container">
            <img
              src="/img/dilverbloom-products/product-03.jpg"
              alt="Dilverbloom pasta flour selection"
              className="sourcing-image"
            />
          </div>
          <div className="sourcing-text">
            <h2>SOURCING THE BEST</h2>
            <p className="sourcing-description">
              Every year we travel across Italy to find the best products and
              meet the best producers.
            </p>
          </div>
        </div>
      </section>

      {/* Recipes Section */}
      <section className="recipes-section">
        <div className="recipes-content">
          <div className="recipes-card">
            <img
              src="/img/dilverbloom-products/product-20.jpg"
              alt="Dilverbloom Italian confectionery"
              className="recipes-image"
            />
            <div className="recipes-text">
              <h3>Dilverbloom RECIPES</h3>
              <h2>Get the Secret Sauce</h2>
              <p>
                Browse Dilverbloom's classic recipes for dishes we turn to time
                and again—perfect for family meals, gatherings, or impressing
                your guests with something new.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
